import React from 'react';
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import './Statements.css';

function ImageInvoice({ img, open, setOpen }) {
    const handleDownload = async () => {
        try {
            const response = await fetch(img);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'invoice.jpg';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Failed to download image", error);
        }
    };

    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            center
            classNames={{
                modal: `pop_image_invoice`,
            }}
            focusTrapped={false}
            overlayOpacity={0.5}
        >
            <div className='div_pop_image_invoice'>
                <i className='fa fa-download' onClick={handleDownload}></i>
                <img src={img} alt="Invoice" />
            </div>
        </RModal>
    );
}

export default ImageInvoice;